import React from 'react';

const ParticularesCard = ({ imagen, texto }) => {
    return (
        <div id="particular-card" className="w-auto flex items-center">
            <div id="particular-card-img-container">
                <img className="w-full h-full" src={imagen} alt="img" />
            </div>
            <div id="particular-card-titulo">
                <h3 className="poppins-600 text-neutral-950">{texto}</h3>
            </div>
        </div>
    );
}

export default ParticularesCard;
